"use client";

import React, { useEffect, useState } from "react";
import { translations } from "@/messages";
type CountdownProps = {
  countdownTo: Date;
  typedLocale: keyof typeof translations;
};
export const Countdown: React.FC<CountdownProps> = ({
  countdownTo,
  typedLocale
}) => {
  const [remainingTime, setRemainingTime] = useState<number | null>(null);
  const [progressPercentage, setProgressPercentage] = useState(100);
  useEffect(() => {
    if (!countdownTo) return;
    const endTime = countdownTo.getTime();
    const totalDuration = endTime - Date.now();
    const intervalId = setInterval(() => {
      const now = Date.now();
      const remaining = Math.max(endTime - now, 0);
      setRemainingTime(Math.ceil(remaining / 1000));
      setProgressPercentage(Math.max(remaining / totalDuration * 100, 0));
      if (remaining <= 0) {
        clearInterval(intervalId);
      }
    }, 1000);
    return () => clearInterval(intervalId);
  }, [countdownTo]);
  if (remainingTime === null || remainingTime <= 0) return null;
  const padTime = (time: number) => time.toString().padStart(2, "0");
  const days = Math.floor(remainingTime / (24 * 60 * 60));
  const hours = Math.floor(remainingTime % (24 * 60 * 60) / (60 * 60));
  const minutes = Math.floor(remainingTime % (60 * 60) / 60);
  const seconds = remainingTime % 60;
  return <div className="mt-4 w-full" data-sentry-component="Countdown" data-sentry-source-file="Countdown.tsx">
      <div className="mb-3">{translations[typedLocale]["formCountdown"]["averageTime"]}</div>
      <div className="h-2 w-full overflow-hidden rounded-full bg-card-foreground/10">
        <div className="transition-width h-full bg-green-500 duration-1000 ease-linear" style={{
        width: `${progressPercentage}%`
      }} />
      </div>
      <div className="mt-3 flex justify-between text-center text-lg font-bold text-card-foreground">
        <div className="flex flex-col items-center">
          <span className="text-2xl">{padTime(days)}</span>
          <span className="text-xs font-normal text-gray-400">
            {translations[typedLocale]["time"]["days"]}
          </span>
        </div>

        <div className="text-gray-300">:</div>

        <div className="flex flex-col items-center">
          <span className="text-2xl">{padTime(hours)}</span>
          <span className="text-xs font-normal text-gray-400">
            {translations[typedLocale]["time"]["hours"]}
          </span>
        </div>

        <div className="text-gray-300">:</div>

        <div className="flex flex-col items-center">
          <span className="text-2xl">{padTime(minutes)}</span>
          <span className="text-xs font-normal text-gray-400">
            {translations[typedLocale]["time"]["minutes"]}
          </span>
        </div>

        <div className="text-gray-300">:</div>

        <div className="flex flex-col items-center">
          <span className="text-2xl">{padTime(seconds)}</span>
          <span className="text-xs font-normal text-gray-400">
            {translations[typedLocale]["time"]["seconds"]}
          </span>
        </div>
      </div>
    </div>;
};